"use strict";
import { Flex } from "ui/src";
export default function LogoProvider({
  color: _color = "",
  size = 24
}) {
  const dim = typeof size === "number" ? `${size}px` : size;
  return <img
    src="/logo.svg"
    alt="Topaz Dex"
    width={dim}
    height={dim}
    style={{ display: "block", objectFit: "contain" }}
    draggable={false}
  />;
}
const RoundedLogo = ({
  size = 24,
  color: _color = "",
  ...rest
}) => {
  const logoSize = size === "100%" ? size : size - 20 * (size / 100);
  return <Flex {...rest} height={size} width={size} centered borderRadius={"$roundedFull"} overflow="hidden">
      <LogoProvider size={logoSize} />
    </Flex>;
};
export { RoundedLogo };
